import { ICourse, IStatisticUser } from '../typings/admin';

export const ADMIN_MOCK_USER = {
  id: 1,
  username: 'ivanov',
  first_name: 'Иван',
  last_name: 'Иванович',
  description: '',
  design: 1,
  webinars: false,
  password: '123',
  old_password: '123',
  user_status: 1,
  is_active: false,
  company: 1,
  company_title: 'test company',
  curator_company: [1],
  time_limitation: '',
  date_joined: '',
  courses: [
    {
      id: 230,
      title: 'Осмотрщик нефтеналивных емкостей',
      description:
        '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
      author: 1,
      last_test_passings: [
        {
          id: 5599,
          task: 422,
          is_final_task: true,
          success_passed: 0,
          response_rate: '88%',
          start_time: '2022-04-15T05:34:50.890176Z',
          finish_time: '2022-04-15T05:38:26.468793Z',
          course: 230,
          retake_seconds: 1000,
          out_of_time: false,
          travel_time: 2000,
        },
        {
          id: 5532,
          task: 420,
          is_final_task: false,
          success_passed: 0,
          response_rate: '92%',
          start_time: '2022-03-30T11:59:07.215095Z',
          finish_time: '2022-03-30T12:27:42.114990Z',
          course: 230,
          retake_seconds: 1000,
          out_of_time: false,
          travel_time: 2000,
        },
      ],
    },
  ],
  start_course: '',
  last_passing_dt: '',
  end_course: '',
  teacher_chat: false,
  group_chat: false,
  tech_chat: false,
  on_check: 0,
  finish_time_exam: '',
  company_name: '',
  course_id: 1,
  last_test_passings: [],
};

export const ADMIN_USERS_MOCK = {
  count: 3548,
  next: 'http://lms.promr-group.pp.ua/api/v1/users/user/?ordering=-id&page=2&page_size=50&search=&user_status=2',
  previous: null,
  results: [
    {
      id: 4580,
      username: 'kv.mazhanas',
      first_name: 'Мажанас Косто Витаунасович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: 'acd17a05',
      user_status: 2,
      is_active: false,
      company: 91,
      company_title: 'АО «МГТ «КАВКАЗ»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-20T16:27:59.630410Z',
      courses: [
        {
          id: 245,
          title: 'Электромонтер по ремонту аппаратуры, релейной защиты и автоматики',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [],
        },
        {
          id: 241,
          title: 'Высокоскоростной поезд Сапсан',
          description: '',
          author: 1,
          last_test_passings: [],
        },
        {
          id: 89,
          title: 'Машинист мотовоза',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать все промежуточные тесты и итоговый экзамен .&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5710,
              task: 220,
              is_final_task: false,
              success_passed: 4,
              response_rate: '17%',
              start_time: '2022-05-23T08:30:45.460591Z',
              finish_time: '2022-05-23T08:42:35.704825Z',
              course: 89,
            },
          ],
        },
      ],
      start_course: '2022-05-23',
      end_course: '2022-07-18',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: null,
      last_test_passings: [
        {
          id: 5710,
          task: 220,
          is_final_task: false,
          success_passed: 4,
          response_rate: '17%',
          start_time: '2022-05-23T08:30:45.460591Z',
          finish_time: '2022-05-23T08:42:35.704825Z',
          course: 89,
        },
      ],
    },
    {
      id: 4579,
      username: 'av.ludan',
      first_name: 'Лудан Александр Викторович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: 'deb5c67c',
      user_status: 2,
      is_active: false,
      company: 91,
      company_title: 'АО «МГТ «КАВКАЗ»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-20T16:27:59.505611Z',
      courses: [
        {
          id: 89,
          title: 'Машинист мотовоза',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать все промежуточные тесты и итоговый экзамен .&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;</p>',
          author: 1,
          last_test_passings: [],
        },
      ],
      start_course: '2022-05-23',
      end_course: '2022-07-18',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: null,
      last_test_passings: [],
    },
    {
      id: 4578,
      username: 'ds.akinfeev',
      first_name: 'Акинфеев Денис Сергеевич',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: 'f861c6ef',
      user_status: 2,
      is_active: true,
      company: 41,
      company_title: 'Улан-Удэнский ЛВРЗ - филиал АО «Желдорреммаш»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-20T16:15:54.570419Z',
      courses: [
        {
          id: 17,
          title: 'Машинист тепловоза',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать все промежуточные тесты и итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;</p>',
          author: 1,
          last_test_passings: [],
        },
      ],
      start_course: '2022-05-26',
      end_course: '2022-08-09',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: null,
      last_test_passings: [],
    },
    {
      id: 4577,
      username: 'ms.savelev',
      first_name: 'Савельев Максим Сергеевич',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '4bfd92fa',
      user_status: 2,
      is_active: true,
      company: 41,
      company_title: 'Улан-Удэнский ЛВРЗ - филиал АО «Желдорреммаш»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-20T16:09:39.904601Z',
      courses: [
        {
          id: 86,
          title: 'Машинист крана (крановщик): железнодорожный кран',
          description:
            '<p style="text-align:start;"><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;"><strong>Добро</strong></span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;"><strong>пожаловать</strong></span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;"><strong>на</strong></span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;"><strong>образовательный</strong></span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;"><strong>портал</strong></span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;"><strong>! </strong></span>&nbsp;</p>\n<p style="text-align:start;"><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">Для</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">зачета</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">по</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">курсу</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">необходимо</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">сдать</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">итоговый</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">экзамен</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">.</span>&nbsp;</p>\n<p style="text-align:start;"><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">Если</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">у</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">вас</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">появятся</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">вопросы</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">по</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">работе</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">портала</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">, </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">по</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">содержанию</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">и</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">качеству</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">учебных</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">материалов</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">, </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">по</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">тестированию</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">и</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">по</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">датам</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">обучения</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;"> - </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">можно</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">обращаться</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">в</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">отдел</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">поддержки</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">: </span>&nbsp;</p>\n<p style="text-align:start;"><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">тел</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">. +7 (495) 663-71-07, </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">доб</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">. 101, </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">пн</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">-</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">пт</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;"> 10:00-19:00 </span>&nbsp;</p>\n<p style="text-align:start;"><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">WhatsApp: +7 (915) 207-01-37</span>&nbsp;</p>\n<p style="text-align:start;"><span style="color: rgb(33,37,41);background-color: rgb(255,255,255);font-size: 16px;font-family: FSAlbert;">e-mail: support@promrg.ru </span></p>\n<p style="text-align:start;"><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">или</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">через</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">чат</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;"> "</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">Служба</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">поддержки</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">" (</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">в</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">меню</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">слева</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">: </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">Информация</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">о</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">курсе</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;"> - </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">Материалы</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">курса</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;"> - </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">Служба</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">поддержки</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">)</span>&nbsp;</p>',
          author: 1,
          last_test_passings: [],
        },
      ],
      start_course: '2022-05-26',
      end_course: '2022-07-07',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: null,
      last_test_passings: [],
    },
    {
      id: 4576,
      username: 'dg.mogilyovcev',
      first_name: 'Могилёвцев Данила Григорьевич',
      last_name: '',
      description: null,
      design: 1,
      webinars: false,
      old_password: '77aa',
      user_status: 2,
      is_active: true,
      company: 155,
      company_title: 'ООО Техцентр «ЛУКОМ-А»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-20T13:52:21.239732Z',
      courses: [
        {
          id: 129,
          title: 'Построение систем контроля и управления доступом',
          description: '<p><br></p>',
          author: 1,
          last_test_passings: [],
        },
      ],
      start_course: '2022-05-30',
      end_course: '2022-06-03',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: null,
      last_test_passings: [],
    },
    {
      id: 4575,
      username: 'no.kostyuk',
      first_name: 'Костюк Николай Олегович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: 'c33ce7c8',
      user_status: 2,
      is_active: true,
      company: 29,
      company_title: 'Физическое лицо',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-19T15:53:41.893112Z',
      courses: [
        {
          id: 46,
          title: 'Слесарь-электрик по ремонту электрооборудования',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5709,
              task: 129,
              is_final_task: true,
              success_passed: 0,
              response_rate: '92%',
              start_time: '2022-05-23T07:33:44.690863Z',
              finish_time: '2022-05-23T09:54:32.459347Z',
              course: 46,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-07-04',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-05-23T09:54:32.459347Z',
      last_test_passings: [
        {
          id: 5709,
          task: 129,
          is_final_task: true,
          success_passed: 0,
          response_rate: '92%',
          start_time: '2022-05-23T07:33:44.690863Z',
          finish_time: '2022-05-23T09:54:32.459347Z',
          course: 46,
        },
      ],
    },
    {
      id: 4574,
      username: 'ee.fedorov',
      first_name: 'Федоров Евгений Эдуардович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '5a148bd7',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:12:57.438832Z',
      courses: [],
      start_course: '2022-05-17',
      end_course: '2022-06-30',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: null,
      last_test_passings: [],
    },
    {
      id: 4573,
      username: 'as.smirnov',
      first_name: 'Смирнов Алексей Сергеевич',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '4fc7112c',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:12:32.940347Z',
      courses: [
        {
          id: 118,
          title: 'Дефектоскопист по магнитному контролю',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5915,
              task: 284,
              is_final_task: true,
              success_passed: 4,
              response_rate: '40%',
              start_time: '2022-06-28T11:46:53.330462Z',
              finish_time: '2022-06-28T12:47:13.307171Z',
              course: 118,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-30',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: null,
      last_test_passings: [
        {
          id: 5915,
          task: 284,
          is_final_task: true,
          success_passed: 4,
          response_rate: '40%',
          start_time: '2022-06-28T11:46:53.330462Z',
          finish_time: '2022-06-28T12:47:13.307171Z',
          course: 118,
        },
      ],
    },
    {
      id: 4572,
      username: 'av.menshikov',
      first_name: 'Меньшиков Александр Владимирович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: 'eb338168',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:11:23.658472Z',
      courses: [
        {
          id: 46,
          title: 'Слесарь-электрик по ремонту электрооборудования',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5729,
              task: 129,
              is_final_task: true,
              success_passed: 0,
              response_rate: '89%',
              start_time: '2022-05-28T10:45:18.767347Z',
              finish_time: '2022-05-28T12:12:42.187922Z',
              course: 46,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-05-28T12:12:42.187922Z',
      last_test_passings: [
        {
          id: 5729,
          task: 129,
          is_final_task: true,
          success_passed: 0,
          response_rate: '89%',
          start_time: '2022-05-28T10:45:18.767347Z',
          finish_time: '2022-05-28T12:12:42.187922Z',
          course: 46,
        },
      ],
    },
    {
      id: 4571,
      username: 'go.shmalko',
      first_name: 'Шмалько Григорий Олегович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '68c7d90f',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:09:55.428966Z',
      courses: [
        {
          id: 101,
          title: 'Электромонтер по ремонту и обслуживанию электрооборудования',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5775,
              task: 250,
              is_final_task: true,
              success_passed: 0,
              response_rate: '88%',
              start_time: '2022-06-03T18:48:53.483166Z',
              finish_time: '2022-06-03T19:23:43.627470Z',
              course: 101,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-03T19:23:43.627470Z',
      last_test_passings: [
        {
          id: 5775,
          task: 250,
          is_final_task: true,
          success_passed: 0,
          response_rate: '88%',
          start_time: '2022-06-03T18:48:53.483166Z',
          finish_time: '2022-06-03T19:23:43.627470Z',
          course: 101,
        },
      ],
    },
    {
      id: 4570,
      username: 'im.baymuhametov',
      first_name: 'Баймухаметов Ильдар Минзакирович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: 'b9acca14',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:09:55.268896Z',
      courses: [
        {
          id: 101,
          title: 'Электромонтер по ремонту и обслуживанию электрооборудования',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5758,
              task: 250,
              is_final_task: true,
              success_passed: 0,
              response_rate: '90%',
              start_time: '2022-06-01T20:10:40.899945Z',
              finish_time: '2022-06-01T21:14:42.700044Z',
              course: 101,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-01T21:14:42.700044Z',
      last_test_passings: [
        {
          id: 5758,
          task: 250,
          is_final_task: true,
          success_passed: 0,
          response_rate: '90%',
          start_time: '2022-06-01T20:10:40.899945Z',
          finish_time: '2022-06-01T21:14:42.700044Z',
          course: 101,
        },
      ],
    },
    {
      id: 4569,
      username: 'ds.ozerov',
      first_name: 'Озеров Дмитрий Сергеевич',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '933bb9dd',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:09:24.040692Z',
      courses: [
        {
          id: 161,
          title: 'Стропальщик',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5771,
              task: 351,
              is_final_task: true,
              success_passed: 0,
              response_rate: '72%',
              start_time: '2022-06-03T12:30:56.319265Z',
              finish_time: '2022-06-03T12:44:04.580686Z',
              course: 161,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-03T12:44:04.580686Z',
      last_test_passings: [
        {
          id: 5771,
          task: 351,
          is_final_task: true,
          success_passed: 0,
          response_rate: '72%',
          start_time: '2022-06-03T12:30:56.319265Z',
          finish_time: '2022-06-03T12:44:04.580686Z',
          course: 161,
        },
      ],
    },
    {
      id: 4568,
      username: 'av.matveev',
      first_name: 'Матвеев Александр Владимирович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: 'd7ba7241',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:09:23.949972Z',
      courses: [
        {
          id: 161,
          title: 'Стропальщик',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5834,
              task: 351,
              is_final_task: true,
              success_passed: 0,
              response_rate: '79%',
              start_time: '2022-06-11T20:00:23.052928Z',
              finish_time: '2022-06-11T20:36:37.092462Z',
              course: 161,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-11T20:36:37.092462Z',
      last_test_passings: [
        {
          id: 5834,
          task: 351,
          is_final_task: true,
          success_passed: 0,
          response_rate: '79%',
          start_time: '2022-06-11T20:00:23.052928Z',
          finish_time: '2022-06-11T20:36:37.092462Z',
          course: 161,
        },
      ],
    },
    {
      id: 4567,
      username: 'vl.badulin',
      first_name: 'Бадулин Владимир Леонидович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '3dcda902',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:09:23.802545Z',
      courses: [
        {
          id: 161,
          title: 'Стропальщик',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5825,
              task: 351,
              is_final_task: true,
              success_passed: 0,
              response_rate: '72%',
              start_time: '2022-06-10T01:30:11.336479Z',
              finish_time: '2022-06-10T02:08:22.858132Z',
              course: 161,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-10T02:08:22.858132Z',
      last_test_passings: [
        {
          id: 5825,
          task: 351,
          is_final_task: true,
          success_passed: 0,
          response_rate: '72%',
          start_time: '2022-06-10T01:30:11.336479Z',
          finish_time: '2022-06-10T02:08:22.858132Z',
          course: 161,
        },
      ],
    },
    {
      id: 4566,
      username: 'sa.yankov',
      first_name: 'Янков Сергей Андреевич',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '24e0a339',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:08:52.216544Z',
      courses: [
        {
          id: 113,
          title: 'Водитель',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5745,
              task: 274,
              is_final_task: true,
              success_passed: 0,
              response_rate: '88%',
              start_time: '2022-05-30T16:09:55.533805Z',
              finish_time: '2022-05-30T17:26:19.226668Z',
              course: 113,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-05-30T17:26:19.226668Z',
      last_test_passings: [
        {
          id: 5745,
          task: 274,
          is_final_task: true,
          success_passed: 0,
          response_rate: '88%',
          start_time: '2022-05-30T16:09:55.533805Z',
          finish_time: '2022-05-30T17:26:19.226668Z',
          course: 113,
        },
      ],
    },
    {
      id: 4565,
      username: 'fv.mishin',
      first_name: 'Мишин Филипп Вячеславович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '70b8bb5c',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:08:52.006820Z',
      courses: [
        {
          id: 113,
          title: 'Водитель',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5840,
              task: 274,
              is_final_task: true,
              success_passed: 0,
              response_rate: '88%',
              start_time: '2022-06-13T11:37:00.347434Z',
              finish_time: '2022-06-13T12:35:01.201909Z',
              course: 113,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-13T12:35:01.201909Z',
      last_test_passings: [
        {
          id: 5840,
          task: 274,
          is_final_task: true,
          success_passed: 0,
          response_rate: '88%',
          start_time: '2022-06-13T11:37:00.347434Z',
          finish_time: '2022-06-13T12:35:01.201909Z',
          course: 113,
        },
      ],
    },
    {
      id: 4564,
      username: 'ma.kozhevnikov',
      first_name: 'Кожевников Михаил Александрович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '210e1b9f',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:08:51.887612Z',
      courses: [
        {
          id: 113,
          title: 'Водитель',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5742,
              task: 274,
              is_final_task: true,
              success_passed: 0,
              response_rate: '75%',
              start_time: '2022-05-30T13:41:07.957742Z',
              finish_time: '2022-05-30T13:59:55.906470Z',
              course: 113,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-05-30T13:59:55.906470Z',
      last_test_passings: [
        {
          id: 5742,
          task: 274,
          is_final_task: true,
          success_passed: 0,
          response_rate: '75%',
          start_time: '2022-05-30T13:41:07.957742Z',
          finish_time: '2022-05-30T13:59:55.906470Z',
          course: 113,
        },
      ],
    },
    {
      id: 4563,
      username: 'aa.vasilev',
      first_name: 'Васильев Алексей Александрович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '88075f74',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:08:51.759851Z',
      courses: [
        {
          id: 113,
          title: 'Водитель',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5784,
              task: 274,
              is_final_task: true,
              success_passed: 0,
              response_rate: '82%',
              start_time: '2022-06-06T18:44:13.106269Z',
              finish_time: '2022-06-06T20:42:39.958550Z',
              course: 113,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-06T20:42:39.958550Z',
      last_test_passings: [
        {
          id: 5784,
          task: 274,
          is_final_task: true,
          success_passed: 0,
          response_rate: '82%',
          start_time: '2022-06-06T18:44:13.106269Z',
          finish_time: '2022-06-06T20:42:39.958550Z',
          course: 113,
        },
      ],
    },
    {
      id: 4562,
      username: 'sv.suhin',
      first_name: 'Сухин Сергей Владимирович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: 'e3694272',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:08:09.583115Z',
      courses: [
        {
          id: 150,
          title: 'Машинист компрессорных установок',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5773,
              task: 329,
              is_final_task: true,
              success_passed: 0,
              response_rate: '90%',
              start_time: '2022-06-03T17:12:51.618308Z',
              finish_time: '2022-06-03T18:54:51.023309Z',
              course: 150,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-03T18:54:51.023309Z',
      last_test_passings: [
        {
          id: 5773,
          task: 329,
          is_final_task: true,
          success_passed: 0,
          response_rate: '90%',
          start_time: '2022-06-03T17:12:51.618308Z',
          finish_time: '2022-06-03T18:54:51.023309Z',
          course: 150,
        },
      ],
    },
    {
      id: 4561,
      username: 'ov.romanova',
      first_name: 'Романова Ольга Васильевна',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: 'e27793d2',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:08:09.416674Z',
      courses: [
        {
          id: 150,
          title: 'Машинист компрессорных установок',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5748,
              task: 329,
              is_final_task: true,
              success_passed: 0,
              response_rate: '96%',
              start_time: '2022-05-31T10:07:31.752621Z',
              finish_time: '2022-05-31T11:36:44.436008Z',
              course: 150,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-05-31T11:36:44.436008Z',
      last_test_passings: [
        {
          id: 5748,
          task: 329,
          is_final_task: true,
          success_passed: 0,
          response_rate: '96%',
          start_time: '2022-05-31T10:07:31.752621Z',
          finish_time: '2022-05-31T11:36:44.436008Z',
          course: 150,
        },
      ],
    },
    {
      id: 4560,
      username: 'da.polishuk',
      first_name: 'Полищук Дмитрий Анатольевич',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '25c908b6',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:08:09.234482Z',
      courses: [
        {
          id: 150,
          title: 'Машинист компрессорных установок',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5776,
              task: 329,
              is_final_task: true,
              success_passed: 0,
              response_rate: '90%',
              start_time: '2022-06-04T08:43:02.568628Z',
              finish_time: '2022-06-04T09:34:27.090531Z',
              course: 150,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-04T09:34:27.090531Z',
      last_test_passings: [
        {
          id: 5776,
          task: 329,
          is_final_task: true,
          success_passed: 0,
          response_rate: '90%',
          start_time: '2022-06-04T08:43:02.568628Z',
          finish_time: '2022-06-04T09:34:27.090531Z',
          course: 150,
        },
      ],
    },
    {
      id: 4559,
      username: 'a .leoshko',
      first_name: 'Леошко Александр  Петрович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '22ff9f25',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:08:09.070586Z',
      courses: [
        {
          id: 150,
          title: 'Машинист компрессорных установок',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5790,
              task: 329,
              is_final_task: true,
              success_passed: 0,
              response_rate: '90%',
              start_time: '2022-06-07T09:54:42.124959Z',
              finish_time: '2022-06-07T11:20:16.661688Z',
              course: 150,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-07T11:20:16.661688Z',
      last_test_passings: [
        {
          id: 5790,
          task: 329,
          is_final_task: true,
          success_passed: 0,
          response_rate: '90%',
          start_time: '2022-06-07T09:54:42.124959Z',
          finish_time: '2022-06-07T11:20:16.661688Z',
          course: 150,
        },
      ],
    },
    {
      id: 4558,
      username: 'vs.anisimov',
      first_name: 'Анисимов Владимир Сергеевич',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '53ebea5b',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:08:08.944801Z',
      courses: [
        {
          id: 150,
          title: 'Машинист компрессорных установок',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5867,
              task: 329,
              is_final_task: true,
              success_passed: 0,
              response_rate: '90%',
              start_time: '2022-06-16T10:01:51.106364Z',
              finish_time: '2022-06-16T10:02:06.043296Z',
              course: 150,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-16T10:02:06.043296Z',
      last_test_passings: [
        {
          id: 5867,
          task: 329,
          is_final_task: true,
          success_passed: 0,
          response_rate: '90%',
          start_time: '2022-06-16T10:01:51.106364Z',
          finish_time: '2022-06-16T10:02:06.043296Z',
          course: 150,
        },
      ],
    },
    {
      id: 4557,
      username: 'nn.motorin',
      first_name: 'Моторин Николай Николаевич',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '05c5e6a4',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:06:55.466256Z',
      courses: [
        {
          id: 68,
          title: 'Оператор котельной',
          description:
            '<p><strong>Добро пожаловать на образовательный портал! </strong></p><p>Для зачета по курсу необходимо сдать итоговый экзамен.</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00</p><p>WhatsApp: +7 (915) 207-01-37</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;</p>',
          author: 1,
          last_test_passings: [],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: null,
      last_test_passings: [],
    },
    {
      id: 4556,
      username: 'vv.liskonog',
      first_name: 'Лисконог Виктор Викторович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: 'f228684e',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:06:55.360948Z',
      courses: [
        {
          id: 68,
          title: 'Оператор котельной',
          description:
            '<p><strong>Добро пожаловать на образовательный портал! </strong></p><p>Для зачета по курсу необходимо сдать итоговый экзамен.</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00</p><p>WhatsApp: +7 (915) 207-01-37</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5821,
              task: 179,
              is_final_task: true,
              success_passed: 0,
              response_rate: '75%',
              start_time: '2022-06-09T15:19:29.465749Z',
              finish_time: '2022-06-09T16:32:32.208310Z',
              course: 68,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-09T16:32:32.208310Z',
      last_test_passings: [
        {
          id: 5821,
          task: 179,
          is_final_task: true,
          success_passed: 0,
          response_rate: '75%',
          start_time: '2022-06-09T15:19:29.465749Z',
          finish_time: '2022-06-09T16:32:32.208310Z',
          course: 68,
        },
      ],
    },
    {
      id: 4555,
      username: 'vm.kudryashov',
      first_name: 'Кудряшов Вячеслав Михайлович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: 'c74a22b1',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:06:55.259739Z',
      courses: [
        {
          id: 68,
          title: 'Оператор котельной',
          description:
            '<p><strong>Добро пожаловать на образовательный портал! </strong></p><p>Для зачета по курсу необходимо сдать итоговый экзамен.</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00</p><p>WhatsApp: +7 (915) 207-01-37</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5820,
              task: 179,
              is_final_task: true,
              success_passed: 0,
              response_rate: '75%',
              start_time: '2022-06-09T15:11:58.358050Z',
              finish_time: '2022-06-09T15:57:13.608028Z',
              course: 68,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-09T15:57:13.608028Z',
      last_test_passings: [
        {
          id: 5820,
          task: 179,
          is_final_task: true,
          success_passed: 0,
          response_rate: '75%',
          start_time: '2022-06-09T15:11:58.358050Z',
          finish_time: '2022-06-09T15:57:13.608028Z',
          course: 68,
        },
      ],
    },
    {
      id: 4554,
      username: 'ig.garbuzov',
      first_name: 'Гарбузов Игорь Геннадьевич',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '340e0b71',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:06:55.162855Z',
      courses: [
        {
          id: 68,
          title: 'Оператор котельной',
          description:
            '<p><strong>Добро пожаловать на образовательный портал! </strong></p><p>Для зачета по курсу необходимо сдать итоговый экзамен.</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00</p><p>WhatsApp: +7 (915) 207-01-37</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5832,
              task: 179,
              is_final_task: true,
              success_passed: 0,
              response_rate: '80%',
              start_time: '2022-06-11T14:16:47.811525Z',
              finish_time: '2022-06-11T14:19:21.506432Z',
              course: 68,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-11T14:19:21.506432Z',
      last_test_passings: [
        {
          id: 5832,
          task: 179,
          is_final_task: true,
          success_passed: 0,
          response_rate: '80%',
          start_time: '2022-06-11T14:16:47.811525Z',
          finish_time: '2022-06-11T14:19:21.506432Z',
          course: 68,
        },
      ],
    },
    {
      id: 4553,
      username: 'yui.bushnyakov',
      first_name: 'Бушняков Юрий Иванович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '5500f9e0',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:06:55.067101Z',
      courses: [
        {
          id: 68,
          title: 'Оператор котельной',
          description:
            '<p><strong>Добро пожаловать на образовательный портал! </strong></p><p>Для зачета по курсу необходимо сдать итоговый экзамен.</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00</p><p>WhatsApp: +7 (915) 207-01-37</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5822,
              task: 179,
              is_final_task: true,
              success_passed: 0,
              response_rate: '75%',
              start_time: '2022-06-09T16:27:42.472866Z',
              finish_time: '2022-06-09T16:36:03.632387Z',
              course: 68,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-09T16:36:03.632387Z',
      last_test_passings: [
        {
          id: 5822,
          task: 179,
          is_final_task: true,
          success_passed: 0,
          response_rate: '75%',
          start_time: '2022-06-09T16:27:42.472866Z',
          finish_time: '2022-06-09T16:36:03.632387Z',
          course: 68,
        },
      ],
    },
    {
      id: 4552,
      username: 'vf.baranov',
      first_name: 'Баранов Василий Федорович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '920642d3',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:06:54.919641Z',
      courses: [
        {
          id: 68,
          title: 'Оператор котельной',
          description:
            '<p><strong>Добро пожаловать на образовательный портал! </strong></p><p>Для зачета по курсу необходимо сдать итоговый экзамен.</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00</p><p>WhatsApp: +7 (915) 207-01-37</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5833,
              task: 179,
              is_final_task: true,
              success_passed: 0,
              response_rate: '80%',
              start_time: '2022-06-11T14:21:43.315107Z',
              finish_time: '2022-06-11T14:24:38.816017Z',
              course: 68,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-11T14:24:38.816017Z',
      last_test_passings: [
        {
          id: 5833,
          task: 179,
          is_final_task: true,
          success_passed: 0,
          response_rate: '80%',
          start_time: '2022-06-11T14:21:43.315107Z',
          finish_time: '2022-06-11T14:24:38.816017Z',
          course: 68,
        },
      ],
    },
    {
      id: 4551,
      username: 'mv.afanasev',
      first_name: 'Афанасьев Михаил Викторович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '9aa88b9b',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:06:54.772912Z',
      courses: [
        {
          id: 68,
          title: 'Оператор котельной',
          description:
            '<p><strong>Добро пожаловать на образовательный портал! </strong></p><p>Для зачета по курсу необходимо сдать итоговый экзамен.</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00</p><p>WhatsApp: +7 (915) 207-01-37</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5893,
              task: 179,
              is_final_task: true,
              success_passed: 0,
              response_rate: '75%',
              start_time: '2022-06-20T14:19:36.131737Z',
              finish_time: '2022-06-20T14:43:16.659974Z',
              course: 68,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-20T14:43:16.659974Z',
      last_test_passings: [
        {
          id: 5893,
          task: 179,
          is_final_task: true,
          success_passed: 0,
          response_rate: '75%',
          start_time: '2022-06-20T14:19:36.131737Z',
          finish_time: '2022-06-20T14:43:16.659974Z',
          course: 68,
        },
      ],
    },
    {
      id: 4550,
      username: 'da.tysyachev',
      first_name: 'Тысячев Дмитрий Александрович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '5df4ec8e',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:06:37.577634Z',
      courses: [
        {
          id: 86,
          title: 'Машинист крана (крановщик): железнодорожный кран',
          description:
            '<p style="text-align:start;"><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;"><strong>Добро</strong></span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;"><strong>пожаловать</strong></span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;"><strong>на</strong></span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;"><strong>образовательный</strong></span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;"><strong>портал</strong></span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;"><strong>! </strong></span>&nbsp;</p>\n<p style="text-align:start;"><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">Для</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">зачета</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">по</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">курсу</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">необходимо</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">сдать</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">итоговый</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">экзамен</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">.</span>&nbsp;</p>\n<p style="text-align:start;"><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">Если</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">у</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">вас</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">появятся</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">вопросы</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">по</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">работе</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">портала</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">, </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">по</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">содержанию</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">и</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">качеству</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">учебных</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">материалов</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">, </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">по</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">тестированию</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">и</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">по</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">датам</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">обучения</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;"> - </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">можно</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">обращаться</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">в</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">отдел</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">поддержки</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">: </span>&nbsp;</p>\n<p style="text-align:start;"><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">тел</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">. +7 (495) 663-71-07, </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">доб</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">. 101, </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">пн</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">-</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">пт</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;"> 10:00-19:00 </span>&nbsp;</p>\n<p style="text-align:start;"><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">WhatsApp: +7 (915) 207-01-37</span>&nbsp;</p>\n<p style="text-align:start;"><span style="color: rgb(33,37,41);background-color: rgb(255,255,255);font-size: 16px;font-family: FSAlbert;">e-mail: support@promrg.ru </span></p>\n<p style="text-align:start;"><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">или</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">через</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">чат</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;"> "</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">Служба</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">поддержки</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">" (</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">в</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">меню</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">слева</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">: </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">Информация</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">о</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">курсе</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;"> - </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">Материалы</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">курса</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;"> - </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">Служба</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">поддержки</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">)</span>&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5871,
              task: 217,
              is_final_task: true,
              success_passed: 0,
              response_rate: '95%',
              start_time: '2022-06-16T17:26:57.221591Z',
              finish_time: '2022-06-16T17:51:40.173091Z',
              course: 86,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-16T17:51:40.173091Z',
      last_test_passings: [
        {
          id: 5871,
          task: 217,
          is_final_task: true,
          success_passed: 0,
          response_rate: '95%',
          start_time: '2022-06-16T17:26:57.221591Z',
          finish_time: '2022-06-16T17:51:40.173091Z',
          course: 86,
        },
      ],
    },
    {
      id: 4549,
      username: 'ds.kryukov',
      first_name: 'Крюков Дмитрий Сергеевич',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: 'd7e75cdd',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:06:37.481356Z',
      courses: [
        {
          id: 86,
          title: 'Машинист крана (крановщик): железнодорожный кран',
          description:
            '<p style="text-align:start;"><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;"><strong>Добро</strong></span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;"><strong>пожаловать</strong></span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;"><strong>на</strong></span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;"><strong>образовательный</strong></span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;"><strong>портал</strong></span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;"><strong>! </strong></span>&nbsp;</p>\n<p style="text-align:start;"><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">Для</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">зачета</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">по</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">курсу</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">необходимо</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">сдать</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">итоговый</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">экзамен</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">.</span>&nbsp;</p>\n<p style="text-align:start;"><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">Если</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">у</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">вас</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">появятся</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">вопросы</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">по</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">работе</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">портала</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">, </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">по</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">содержанию</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">и</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">качеству</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">учебных</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">материалов</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">, </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">по</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">тестированию</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">и</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">по</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">датам</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">обучения</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;"> - </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">можно</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">обращаться</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">в</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">отдел</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">поддержки</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">: </span>&nbsp;</p>\n<p style="text-align:start;"><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">тел</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">. +7 (495) 663-71-07, </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">доб</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">. 101, </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">пн</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">-</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">пт</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;"> 10:00-19:00 </span>&nbsp;</p>\n<p style="text-align:start;"><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">WhatsApp: +7 (915) 207-01-37</span>&nbsp;</p>\n<p style="text-align:start;"><span style="color: rgb(33,37,41);background-color: rgb(255,255,255);font-size: 16px;font-family: FSAlbert;">e-mail: support@promrg.ru </span></p>\n<p style="text-align:start;"><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">или</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">через</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">чат</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;"> "</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">Служба</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">поддержки</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">" (</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">в</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">меню</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">слева</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">: </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">Информация</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">о</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">курсе</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;"> - </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">Материалы</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">курса</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;"> - </span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">Служба</span> <span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert, sans-serif;">поддержки</span><span style="color: rgb(33,37,41);background-color: white;font-size: 16px;font-family: FSAlbert;">)</span>&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5872,
              task: 217,
              is_final_task: true,
              success_passed: 0,
              response_rate: '90%',
              start_time: '2022-06-16T17:39:35.134081Z',
              finish_time: '2022-06-16T17:56:29.555873Z',
              course: 86,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-16T17:56:29.555873Z',
      last_test_passings: [
        {
          id: 5872,
          task: 217,
          is_final_task: true,
          success_passed: 0,
          response_rate: '90%',
          start_time: '2022-06-16T17:39:35.134081Z',
          finish_time: '2022-06-16T17:56:29.555873Z',
          course: 86,
        },
      ],
    },
    {
      id: 4548,
      username: 'se.kapitalcev',
      first_name: 'Капитальцев Сергей Евгеньевич',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: 'fb8de3ef',
      user_status: 2,
      is_active: true,
      company: 67,
      company_title: 'АО «ФПК»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T22:06:08.302429Z',
      courses: [
        {
          id: 138,
          title: 'Слесарь-инструментальщик',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5810,
              task: 384,
              is_final_task: true,
              success_passed: 0,
              response_rate: '86%',
              start_time: '2022-06-08T16:31:23.817891Z',
              finish_time: '2022-06-08T16:38:48.369406Z',
              course: 138,
            },
          ],
        },
      ],
      start_course: '2022-05-19',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-08T16:38:48.369406Z',
      last_test_passings: [
        {
          id: 5810,
          task: 384,
          is_final_task: true,
          success_passed: 0,
          response_rate: '86%',
          start_time: '2022-06-08T16:31:23.817891Z',
          finish_time: '2022-06-08T16:38:48.369406Z',
          course: 138,
        },
      ],
    },
    {
      id: 4547,
      username: '28_05_2022',
      first_name: 'test_user',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '123',
      user_status: 2,
      is_active: true,
      company: 154,
      company_title: 'test',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-18T17:02:30.481482Z',
      courses: [
        {
          id: 117,
          title: 'Бригадир (освобожденный) предприятий железнодорожного транспорта и метрополитена',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5699,
              task: 275,
              is_final_task: true,
              success_passed: 4,
              response_rate: '20%',
              start_time: '2022-05-18T17:02:51.381448Z',
              finish_time: '2022-05-18T17:04:03.706623Z',
              course: 117,
            },
          ],
        },
      ],
      start_course: '2022-05-18',
      end_course: '2022-06-17',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: null,
      last_test_passings: [
        {
          id: 5699,
          task: 275,
          is_final_task: true,
          success_passed: 4,
          response_rate: '20%',
          start_time: '2022-05-18T17:02:51.381448Z',
          finish_time: '2022-05-18T17:04:03.706623Z',
          course: 117,
        },
      ],
    },
    {
      id: 4546,
      username: 'mv.bykanov',
      first_name: 'Быканов Максим Викторович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: 'dff17cfb',
      user_status: 2,
      is_active: true,
      company: 29,
      company_title: 'Физическое лицо',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-16T14:42:28.305241Z',
      courses: [
        {
          id: 130,
          title: 'Слесарь по ремонту подвижного состава',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5738,
              task: 286,
              is_final_task: true,
              success_passed: 0,
              response_rate: '94%',
              start_time: '2022-05-29T17:29:00.816529Z',
              finish_time: '2022-05-29T17:49:39.104717Z',
              course: 130,
            },
          ],
        },
      ],
      start_course: '2022-05-16',
      end_course: '2022-06-29',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-05-29T17:49:39.104717Z',
      last_test_passings: [
        {
          id: 5738,
          task: 286,
          is_final_task: true,
          success_passed: 0,
          response_rate: '94%',
          start_time: '2022-05-29T17:29:00.816529Z',
          finish_time: '2022-05-29T17:49:39.104717Z',
          course: 130,
        },
      ],
    },
    {
      id: 4545,
      username: 'tf.gurina',
      first_name: 'Гурина Татьяна Федоровна',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '2ba48608',
      user_status: 2,
      is_active: true,
      company: 29,
      company_title: 'Физическое лицо',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-16T14:26:10.254910Z',
      courses: [
        {
          id: 130,
          title: 'Слесарь по ремонту подвижного состава',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5690,
              task: 286,
              is_final_task: true,
              success_passed: 0,
              response_rate: '87%',
              start_time: '2022-05-16T18:13:19.692165Z',
              finish_time: '2022-05-16T19:02:59.267536Z',
              course: 130,
            },
          ],
        },
      ],
      start_course: '2022-05-16',
      end_course: '2022-06-16',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-05-16T19:02:59.267536Z',
      last_test_passings: [
        {
          id: 5690,
          task: 286,
          is_final_task: true,
          success_passed: 0,
          response_rate: '87%',
          start_time: '2022-05-16T18:13:19.692165Z',
          finish_time: '2022-05-16T19:02:59.267536Z',
          course: 130,
        },
      ],
    },
    {
      id: 4544,
      username: 'sa.yaroslavcev',
      first_name: 'Ярославцев Сергей Александрович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '9ff4b379',
      user_status: 2,
      is_active: true,
      company: 52,
      company_title: 'ООО «МВПС-Сервис»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-13T16:14:17.446254Z',
      courses: [
        {
          id: 117,
          title: 'Бригадир (освобожденный) предприятий железнодорожного транспорта и метрополитена',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5806,
              task: 275,
              is_final_task: true,
              success_passed: 0,
              response_rate: '85%',
              start_time: '2022-06-08T11:07:08.126394Z',
              finish_time: '2022-06-08T11:17:52.830942Z',
              course: 117,
            },
          ],
        },
      ],
      start_course: '2022-05-16',
      end_course: '2022-06-17',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-08T11:17:52.830942Z',
      last_test_passings: [
        {
          id: 5806,
          task: 275,
          is_final_task: true,
          success_passed: 0,
          response_rate: '85%',
          start_time: '2022-06-08T11:07:08.126394Z',
          finish_time: '2022-06-08T11:17:52.830942Z',
          course: 117,
        },
      ],
    },
    {
      id: 4543,
      username: 'na.yankovskaya',
      first_name: 'Янковская Наталья Александровна',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: 'ecb963d8',
      user_status: 2,
      is_active: true,
      company: 52,
      company_title: 'ООО «МВПС-Сервис»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-13T16:14:17.126416Z',
      courses: [
        {
          id: 117,
          title: 'Бригадир (освобожденный) предприятий железнодорожного транспорта и метрополитена',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5770,
              task: 275,
              is_final_task: true,
              success_passed: 0,
              response_rate: '70%',
              start_time: '2022-06-03T12:11:47.252984Z',
              finish_time: '2022-06-03T13:00:57.169326Z',
              course: 117,
            },
          ],
        },
      ],
      start_course: '2022-05-16',
      end_course: '2022-06-17',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-03T13:00:57.169326Z',
      last_test_passings: [
        {
          id: 5770,
          task: 275,
          is_final_task: true,
          success_passed: 0,
          response_rate: '70%',
          start_time: '2022-06-03T12:11:47.252984Z',
          finish_time: '2022-06-03T13:00:57.169326Z',
          course: 117,
        },
      ],
    },
    {
      id: 4542,
      username: 'ns.hitryh',
      first_name: 'Хитрых Никита Сергеевич',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '48d97967',
      user_status: 2,
      is_active: true,
      company: 52,
      company_title: 'ООО «МВПС-Сервис»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-13T16:14:16.913795Z',
      courses: [
        {
          id: 117,
          title: 'Бригадир (освобожденный) предприятий железнодорожного транспорта и метрополитена',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5885,
              task: 275,
              is_final_task: true,
              success_passed: 4,
              response_rate: '20%',
              start_time: '2022-06-18T06:24:33.902875Z',
              finish_time: '2022-06-18T06:27:32.777765Z',
              course: 117,
            },
          ],
        },
      ],
      start_course: '2022-05-16',
      end_course: '2022-06-17',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: null,
      last_test_passings: [
        {
          id: 5885,
          task: 275,
          is_final_task: true,
          success_passed: 4,
          response_rate: '20%',
          start_time: '2022-06-18T06:24:33.902875Z',
          finish_time: '2022-06-18T06:27:32.777765Z',
          course: 117,
        },
      ],
    },
    {
      id: 4541,
      username: 'dn.haritonov',
      first_name: 'Харитонов Дмитрий Николаевич',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: 'e76cc554',
      user_status: 2,
      is_active: true,
      company: 52,
      company_title: 'ООО «МВПС-Сервис»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-13T16:14:16.670191Z',
      courses: [
        {
          id: 117,
          title: 'Бригадир (освобожденный) предприятий железнодорожного транспорта и метрополитена',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5720,
              task: 275,
              is_final_task: true,
              success_passed: 0,
              response_rate: '70%',
              start_time: '2022-05-25T17:16:17.697637Z',
              finish_time: '2022-05-25T17:55:55.986647Z',
              course: 117,
            },
          ],
        },
      ],
      start_course: '2022-05-16',
      end_course: '2022-06-17',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-05-25T17:55:55.986647Z',
      last_test_passings: [
        {
          id: 5720,
          task: 275,
          is_final_task: true,
          success_passed: 0,
          response_rate: '70%',
          start_time: '2022-05-25T17:16:17.697637Z',
          finish_time: '2022-05-25T17:55:55.986647Z',
          course: 117,
        },
      ],
    },
    {
      id: 4540,
      username: 'ng.sezyomov',
      first_name: 'Сезёмов Николай Геннадьевич',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '9eab9470',
      user_status: 2,
      is_active: true,
      company: 52,
      company_title: 'ООО «МВПС-Сервис»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-13T16:14:16.409710Z',
      courses: [
        {
          id: 117,
          title: 'Бригадир (освобожденный) предприятий железнодорожного транспорта и метрополитена',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5903,
              task: 275,
              is_final_task: true,
              success_passed: 4,
              response_rate: '25%',
              start_time: '2022-06-24T00:01:26.826212Z',
              finish_time: '2022-06-24T00:10:32.030914Z',
              course: 117,
            },
          ],
        },
      ],
      start_course: '2022-05-16',
      end_course: '2022-06-17',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: null,
      last_test_passings: [
        {
          id: 5903,
          task: 275,
          is_final_task: true,
          success_passed: 4,
          response_rate: '25%',
          start_time: '2022-06-24T00:01:26.826212Z',
          finish_time: '2022-06-24T00:10:32.030914Z',
          course: 117,
        },
      ],
    },
    {
      id: 4539,
      username: 'vn.svilin',
      first_name: 'Свилин Вячеслав Николаевич',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: 'dafcc455',
      user_status: 2,
      is_active: true,
      company: 52,
      company_title: 'ООО «МВПС-Сервис»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-13T16:14:16.108728Z',
      courses: [
        {
          id: 117,
          title: 'Бригадир (освобожденный) предприятий железнодорожного транспорта и метрополитена',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5875,
              task: 275,
              is_final_task: true,
              success_passed: 0,
              response_rate: '85%',
              start_time: '2022-06-17T07:31:18.032863Z',
              finish_time: '2022-06-17T08:37:25.799028Z',
              course: 117,
            },
          ],
        },
      ],
      start_course: '2022-05-16',
      end_course: '2022-06-17',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-17T08:37:25.799028Z',
      last_test_passings: [
        {
          id: 5875,
          task: 275,
          is_final_task: true,
          success_passed: 0,
          response_rate: '85%',
          start_time: '2022-06-17T07:31:18.032863Z',
          finish_time: '2022-06-17T08:37:25.799028Z',
          course: 117,
        },
      ],
    },
    {
      id: 4538,
      username: 'em.rybovalov',
      first_name: 'Рыбовалов Евгений Михайлович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '58e875d6',
      user_status: 2,
      is_active: true,
      company: 52,
      company_title: 'ООО «МВПС-Сервис»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-13T16:14:15.717387Z',
      courses: [
        {
          id: 117,
          title: 'Бригадир (освобожденный) предприятий железнодорожного транспорта и метрополитена',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5788,
              task: 275,
              is_final_task: true,
              success_passed: 0,
              response_rate: '65%',
              start_time: '2022-06-07T07:44:07.889708Z',
              finish_time: '2022-06-07T08:29:05.582428Z',
              course: 117,
            },
          ],
        },
      ],
      start_course: '2022-05-16',
      end_course: '2022-06-17',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-07T08:29:05.582428Z',
      last_test_passings: [
        {
          id: 5788,
          task: 275,
          is_final_task: true,
          success_passed: 0,
          response_rate: '65%',
          start_time: '2022-06-07T07:44:07.889708Z',
          finish_time: '2022-06-07T08:29:05.582428Z',
          course: 117,
        },
      ],
    },
    {
      id: 4537,
      username: 'ra.rudyk',
      first_name: 'Рудык Руслан Анатольевич',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '166d7d04',
      user_status: 2,
      is_active: true,
      company: 52,
      company_title: 'ООО «МВПС-Сервис»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-13T16:14:15.333002Z',
      courses: [
        {
          id: 117,
          title: 'Бригадир (освобожденный) предприятий железнодорожного транспорта и метрополитена',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5782,
              task: 275,
              is_final_task: true,
              success_passed: 0,
              response_rate: '75%',
              start_time: '2022-06-06T09:26:13.423039Z',
              finish_time: '2022-06-06T09:57:18.204140Z',
              course: 117,
            },
          ],
        },
      ],
      start_course: '2022-05-16',
      end_course: '2022-06-17',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-06T09:57:18.204140Z',
      last_test_passings: [
        {
          id: 5782,
          task: 275,
          is_final_task: true,
          success_passed: 0,
          response_rate: '75%',
          start_time: '2022-06-06T09:26:13.423039Z',
          finish_time: '2022-06-06T09:57:18.204140Z',
          course: 117,
        },
      ],
    },
    {
      id: 4536,
      username: 'an.presnov',
      first_name: 'Преснов Андрей Николаевич',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '71ddfc8d',
      user_status: 2,
      is_active: true,
      company: 52,
      company_title: 'ООО «МВПС-Сервис»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-13T16:14:15.115069Z',
      courses: [
        {
          id: 117,
          title: 'Бригадир (освобожденный) предприятий железнодорожного транспорта и метрополитена',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5698,
              task: 275,
              is_final_task: true,
              success_passed: 0,
              response_rate: '75%',
              start_time: '2022-05-18T08:23:33.915307Z',
              finish_time: '2022-05-18T09:43:11.319196Z',
              course: 117,
            },
          ],
        },
      ],
      start_course: '2022-05-16',
      end_course: '2022-06-17',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-05-18T09:43:11.319196Z',
      last_test_passings: [
        {
          id: 5698,
          task: 275,
          is_final_task: true,
          success_passed: 0,
          response_rate: '75%',
          start_time: '2022-05-18T08:23:33.915307Z',
          finish_time: '2022-05-18T09:43:11.319196Z',
          course: 117,
        },
      ],
    },
    {
      id: 4535,
      username: 'v.kontorskiy',
      first_name: 'Конторский Виктор',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: 'c3adbb6a',
      user_status: 2,
      is_active: true,
      company: 52,
      company_title: 'ООО «МВПС-Сервис»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-13T16:14:14.905780Z',
      courses: [
        {
          id: 117,
          title: 'Бригадир (освобожденный) предприятий железнодорожного транспорта и метрополитена',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5869,
              task: 275,
              is_final_task: true,
              success_passed: 0,
              response_rate: '70%',
              start_time: '2022-06-16T11:02:17.644046Z',
              finish_time: '2022-06-16T11:36:57.845706Z',
              course: 117,
            },
          ],
        },
      ],
      start_course: '2022-05-16',
      end_course: '2022-06-17',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-16T11:36:57.845706Z',
      last_test_passings: [
        {
          id: 5869,
          task: 275,
          is_final_task: true,
          success_passed: 0,
          response_rate: '70%',
          start_time: '2022-06-16T11:02:17.644046Z',
          finish_time: '2022-06-16T11:36:57.845706Z',
          course: 117,
        },
      ],
    },
    {
      id: 4534,
      username: 'ia.kalashnikov',
      first_name: 'Калашников Игорь Александрович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '14a611f4',
      user_status: 2,
      is_active: true,
      company: 52,
      company_title: 'ООО «МВПС-Сервис»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-13T16:14:14.722369Z',
      courses: [
        {
          id: 117,
          title: 'Бригадир (освобожденный) предприятий железнодорожного транспорта и метрополитена',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5728,
              task: 275,
              is_final_task: true,
              success_passed: 0,
              response_rate: '75%',
              start_time: '2022-05-28T09:07:13.138927Z',
              finish_time: '2022-05-28T09:40:16.159562Z',
              course: 117,
            },
          ],
        },
      ],
      start_course: '2022-05-16',
      end_course: '2022-06-17',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-05-28T09:40:16.159562Z',
      last_test_passings: [
        {
          id: 5728,
          task: 275,
          is_final_task: true,
          success_passed: 0,
          response_rate: '75%',
          start_time: '2022-05-28T09:07:13.138927Z',
          finish_time: '2022-05-28T09:40:16.159562Z',
          course: 117,
        },
      ],
    },
    {
      id: 4533,
      username: 'ayu.ivanov',
      first_name: 'Иванов Андрей Юрьевич',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: 'e04d277a',
      user_status: 2,
      is_active: true,
      company: 52,
      company_title: 'ООО «МВПС-Сервис»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-13T16:14:14.514354Z',
      courses: [
        {
          id: 117,
          title: 'Бригадир (освобожденный) предприятий железнодорожного транспорта и метрополитена',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5732,
              task: 275,
              is_final_task: true,
              success_passed: 0,
              response_rate: '80%',
              start_time: '2022-05-28T15:48:08.712579Z',
              finish_time: '2022-05-28T16:22:37.386932Z',
              course: 117,
            },
          ],
        },
      ],
      start_course: '2022-05-16',
      end_course: '2022-06-17',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-05-28T16:22:37.386932Z',
      last_test_passings: [
        {
          id: 5732,
          task: 275,
          is_final_task: true,
          success_passed: 0,
          response_rate: '80%',
          start_time: '2022-05-28T15:48:08.712579Z',
          finish_time: '2022-05-28T16:22:37.386932Z',
          course: 117,
        },
      ],
    },
    {
      id: 4532,
      username: 'av.zernov',
      first_name: 'Зернов Андрей Владимирович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: 'a35887ad',
      user_status: 2,
      is_active: true,
      company: 52,
      company_title: 'ООО «МВПС-Сервис»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-13T16:14:14.306967Z',
      courses: [
        {
          id: 117,
          title: 'Бригадир (освобожденный) предприятий железнодорожного транспорта и метрополитена',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5756,
              task: 275,
              is_final_task: true,
              success_passed: 0,
              response_rate: '70%',
              start_time: '2022-06-01T16:26:38.874636Z',
              finish_time: '2022-06-01T16:41:09.311847Z',
              course: 117,
            },
          ],
        },
      ],
      start_course: '2022-05-16',
      end_course: '2022-06-17',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-01T16:41:09.311847Z',
      last_test_passings: [
        {
          id: 5756,
          task: 275,
          is_final_task: true,
          success_passed: 0,
          response_rate: '70%',
          start_time: '2022-06-01T16:26:38.874636Z',
          finish_time: '2022-06-01T16:41:09.311847Z',
          course: 117,
        },
      ],
    },
    {
      id: 4531,
      username: 'aa.zhumaev',
      first_name: 'Жумаев Алексей Александрович',
      last_name: '',
      description: null,
      design: 0,
      webinars: false,
      old_password: '4a6d2884',
      user_status: 2,
      is_active: true,
      company: 52,
      company_title: 'ООО «МВПС-Сервис»',
      curator_company: [],
      time_limitation: null,
      date_joined: '2022-05-13T16:14:14.063023Z',
      courses: [
        {
          id: 117,
          title: 'Бригадир (освобожденный) предприятий железнодорожного транспорта и метрополитена',
          description:
            '<p><strong>Добро</strong> <strong>пожаловать</strong> <strong>на</strong> <strong>образовательный</strong> <strong>портал! </strong>&nbsp;</p><p>Для зачета по курсу необходимо сдать итоговый экзамен.&nbsp;</p><p>Если у вас появятся вопросы по работе портала, по содержанию и качеству учебных материалов, по тестированию и по датам обучения - можно обращаться в отдел поддержки:&nbsp;</p><p>тел. +7 (495) 663-71-07, доб. 101, пн-пт 10:00-19:00&nbsp;</p><p>WhatsApp: +7 (915) 207-01-37&nbsp;</p><p>e-mail: support@promrg.ru</p><p>или через чат "Служба поддержки" (в меню слева: Информация о курсе - Материалы курса - Служба поддержки)&nbsp;&nbsp;</p>',
          author: 1,
          last_test_passings: [
            {
              id: 5870,
              task: 275,
              is_final_task: true,
              success_passed: 0,
              response_rate: '70%',
              start_time: '2022-06-16T17:25:46.950363Z',
              finish_time: '2022-06-16T18:25:39.459034Z',
              course: 117,
            },
          ],
        },
      ],
      start_course: '2022-05-16',
      end_course: '2022-06-17',
      teacher_chat: false,
      group_chat: false,
      tech_chat: true,
      on_check: 0,
      last_passing_dt: '2022-06-16T18:25:39.459034Z',
      last_test_passings: [
        {
          id: 5870,
          task: 275,
          is_final_task: true,
          success_passed: 0,
          response_rate: '70%',
          start_time: '2022-06-16T17:25:46.950363Z',
          finish_time: '2022-06-16T18:25:39.459034Z',
          course: 117,
        },
      ],
    },
  ],
};

export const ADMIN_COURSES_MOCK = [
  {
    id: 263,
    title: 'course 5',
    description: null,
    teacher: '',
    author: 1,
    author_name: 'admin',
    moderators: [],
    tag: [],
    users: [],
    created: '2022-07-11T11:52:59.942824Z',
    registered_num: 0,
    visit_num: null,
    completed_num: null,
    is_active: true,
    start_course: null,
    end_course: null,
    t_chat: false,
    s_chat: false,
    g_chat: true,
  },
  {
    id: 262,
    title: 'course 4',
    description: null,
    teacher: '',
    author: 1,
    author_name: 'admin',
    moderators: [],
    tag: [],
    users: [],
    created: '2022-07-11T11:49:53.585433Z',
    registered_num: 0,
    visit_num: null,
    completed_num: null,
    is_active: true,
    start_course: null,
    end_course: null,
    t_chat: false,
    s_chat: false,
    g_chat: true,
  },
  {
    id: 261,
    title: 'course 3',
    description: null,
    teacher: '',
    author: 1,
    author_name: 'admin',
    moderators: [],
    tag: [],
    users: [],
    created: '2022-07-11T11:44:23.555792Z',
    registered_num: 0,
    visit_num: null,
    completed_num: null,
    is_active: true,
    start_course: null,
    end_course: null,
    t_chat: false,
    s_chat: false,
    g_chat: true,
  },
  {
    id: 259,
    title: 'course 2',
    description: null,
    teacher: '',
    author: 1,
    author_name: 'admin',
    moderators: [],
    tag: [],
    users: [2131],
    created: '2022-07-09T16:54:07.157768Z',
    registered_num: 1,
    visit_num: null,
    completed_num: null,
    is_active: true,
    start_course: null,
    end_course: null,
    t_chat: false,
    s_chat: false,
    g_chat: true,
  },
  {
    id: 258,
    title: 'course 1',
    description: null,
    teacher: '',
    author: 1,
    author_name: 'admin',
    moderators: [],
    tag: [],
    users: [],
    created: '2022-07-09T16:54:03.290846Z',
    registered_num: 0,
    visit_num: null,
    completed_num: null,
    is_active: true,
    start_course: null,
    end_course: null,
    t_chat: false,
    s_chat: false,
    g_chat: true,
  },
];

export const CHAT_MOCK = {
  id: 1,
  chat_status: 1,
  users: [1, 2],
  course: 1,
  company: 1,
  num_messages: 1,
  list_users: [
    {
      id: 2,
      username: 'user1',
      first_name: 'user1',
      last_name: 'user1',
      user_status: 2,
      time_limitation: '',
      company: 1,
    },
  ],
  last_message_date: '2022-07-06T10:26:23.110528Z',
};

export const COURSE_MOCK: ICourse = {
  id: 1,
  title: 'course-1',
  description: '<p>edwedwed</p><p><strong>wedwedwed</strong></p><p><em>ewdwedwef</em></p>',
  teacher: '',
  author: 1,
  author_name: 'admin',
  moderators: [],
  tag: [],
  users: [4681, 4682],
  created: '2022-07-20T11:40:29.458500Z',
  registered_num: 2,
  visit_num: 0,
  completed_num: 1,
  is_active: true,
};

export const COURSE_DETAIL_MOCK = {
  ...COURSE_MOCK,
  users_detail: [
    { id: 4681, username: 'user-4681' },
    { id: 4682, username: 'user-4682' },
  ],
};

export const ADMIN_USER_ACTIVITIES_MOCK: IStatisticUser = [
  { id: 13937, user: 4685, course_id: 277, day: '2022-07-26', seconds: 1848 },
  { id: 13938, user: 4685, course_id: 277, day: '2022-07-28', seconds: 3848 },
  { id: 13939, user: 4685, course_id: 277, day: '2022-07-221', seconds: 4848 },
  { id: 13940, user: 4685, course_id: 277, day: '2022-07-30', seconds: 2048 },
];

export const ADMIN_USER_ACTIVITIES_MOCK_SORTED_BY_DATE = [
  {
    course_id: 277,
    day: '2022-07-26',
    id: 13937,
    seconds: 1848,
    unixDate: 1658793600000,
    user: 4685,
  },
  {
    course_id: 277,
    day: '2022-07-28',
    id: 13938,
    seconds: 3848,
    unixDate: 1658966400000,
    user: 4685,
  },
  { course_id: 277, day: '2022-07-221', id: 13939, seconds: 4848, unixDate: NaN, user: 4685 },
  {
    course_id: 277,
    day: '2022-07-30',
    id: 13940,
    seconds: 2048,
    unixDate: 1659139200000,
    user: 4685,
  },
];

export const ADMIN_USER_ACTIVITY_DETAILS_MOCK = [
  {
    id: 41224,
    user: 4685,
    course_id: 277,
    payload: {
      user: 4685,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '103.0.0.0', major: '103' },
      time: 1658868952959,
      course: 277,
    },
  },
  {
    id: 41223,
    user: 4685,
    course_id: 277,
    payload: {
      user: 4685,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '103.0.0.0', major: '103' },
      time: 1658868952990,
      course: 277,
    },
  },
  {
    id: 41222,
    user: 4685,
    course_id: 277,
    payload: {
      user: 4685,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '103.0.0.0', major: '103' },
      time: 1658866812802,
      course: 277,
    },
  },
  {
    id: 41221,
    user: 4685,
    course_id: 277,
    payload: {
      user: 4685,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '103.0.0.0', major: '103' },
      time: 1658866812798,
      course: 277,
    },
  },
];

export const strucutureObj = {
  'Автоматизация контроля в ГПС': 11334,
  'Гибкая автоматизация производства': 11331,
  'Значение и общая характеристика теории производительности и надежности машин': 11338,
  'Инженерные методы расчета экономической эффективности автоматизации производства': 11342,
  'Инструментальная оснастка': 11356,
  'Инструментообеспечение в ГПС': 11333,
  'Классификация технических средств АТСС': 11351,
  'Классификация целевых механизмов': 11335,
  'Координатно-измерительные машины': 11361,
  'Машины и механизмы автоматизации': 11329,
  'Методы расчета производительности машин-автоматов и их систем': 11344,
  'Методы расчета производительности машин-автоматов и их систем----': 11343,
  'Механизмы питания': 11337,
  'Настройка инструмента на размер': 11357,
  'Обеспечение заданной точности обработки в ГПС': 11360,
  'Общие положения': 11359,
  'Общие сведения': 11346,
  'Основные постулаты теории производительности': 11339,
  'Основы оптимального проектирования автоматических систем машин': 11345,
  'Подсистема манипулирования': 11354,
  'Подсистема складирования изделий': 11352,
  'Подсистема транспортирования изделий': 11353,
  'Производительность труда как критерий оценки новой техники': 11340,
  'Пути повышения производительности труда': 11341,
  'Состав системы инструментообеспечения': 11355,
  'Средства гибкой автоматизации производства': 11350,
  'Стратегии организации производства': 11349,
  'Структура ГПС': 11347,
  'Теория производительности машин': 11330,
  'Технические средства АТСС ГПС': 11332,
  'Транспортирование инструмента': 11358,
  'Транспортные механизмы': 11336,
  'Формы организации ГПС': 11348,
};

export const ONLINE_HISTORY_MOCK = [
  { date: '2021-12-01', active_clients_count: 31 },
  { date: '2021-12-02', active_clients_count: 21 },
  { date: '2021-12-03', active_clients_count: 25 },
  { date: '2021-12-04', active_clients_count: 12 },
  { date: '2021-12-05', active_clients_count: 16 },
  { date: '2021-12-06', active_clients_count: 35 },
  { date: '2021-12-07', active_clients_count: 28 },
  { date: '2021-12-08', active_clients_count: 15 },
  { date: '2021-12-09', active_clients_count: 19 },
  { date: '2021-12-10', active_clients_count: 25 },
  { date: '2021-12-11', active_clients_count: 17 },
  { date: '2021-12-12', active_clients_count: 14 },
  { date: '2021-12-13', active_clients_count: 28 },
  { date: '2021-12-14', active_clients_count: 27 },
  { date: '2021-12-15', active_clients_count: 39 },
];

export const USERS_RES_MOCK = [
  {
    id: 4720,
    username: 'as.ermolaev',
    old_password: '123',
  },
  {
    id: 4721,
    username: 'sd.bacula',
    old_password: '123',
  },
  {
    id: 4722,
    username: 'al.fedorov',
    old_password: '123',
  },
  {
    id: 4723,
    username: 'qw.melody',
    old_password: '123',
  },
];

export const ADMINS_RES_MOCK = [
  {
    id: 4720,
    username: 'adm.ermolaev',
    old_password: '123',
  },
  {
    id: 4721,
    username: 'adm.bacula',
    old_password: '123',
  },
  {
    id: 4722,
    username: 'adm.fedorov',
    old_password: '123',
  },
  {
    id: 4723,
    username: 'adm.melody',
    old_password: '123',
  },
];

export const USER_ACTIVITY_MOCK = [
  {
    id: 45008,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668413663310,
      course: 257,
    },
  },
  {
    id: 45009,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668413663319,
      course: 257,
    },
  },
  {
    id: 45010,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668414258773,
      course: 257,
    },
  },
  {
    id: 45011,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668414433122,
      course: 257,
    },
  },
  {
    id: 45012,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668414511689,
      course: 257,
    },
  },
  {
    id: 45013,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668414610527,
      course: 257,
    },
  },
  {
    id: 45014,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668414610575,
      course: 257,
    },
  },
  {
    id: 45015,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668414696382,
      course: 257,
    },
  },
  {
    id: 45016,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668505622022,
      course: 257,
    },
  },
  {
    id: 45017,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668505622120,
      course: 257,
    },
  },
  {
    id: 45018,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668505677159,
      course: 257,
    },
  },
  {
    id: 45019,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668505749528,
      course: 257,
    },
  },
  {
    id: 45020,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668505975099,
      course: 257,
    },
  },
  {
    id: 45021,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668506319980,
      course: 257,
    },
  },
  {
    id: 45022,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668508617960,
      course: 257,
    },
  },
  {
    id: 45023,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668511245429,
      course: 257,
    },
  },
  {
    id: 45024,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668511331120,
      course: 257,
    },
  },
  {
    id: 45025,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668511433874,
      course: 257,
    },
  },
  {
    id: 45026,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668511486155,
      course: 257,
    },
  },
  {
    id: 45027,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668511578169,
      course: 257,
    },
  },
  {
    id: 45028,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668511674732,
      course: 257,
    },
  },
  {
    id: 45029,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668511743770,
      course: 257,
    },
  },
  {
    id: 45030,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668511752448,
      course: 257,
    },
  },
  {
    id: 45031,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668511841100,
      course: 257,
    },
  },
  {
    id: 45032,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668568728489,
      course: 257,
    },
  },
  {
    id: 45033,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668568728499,
      course: 257,
    },
  },
  {
    id: 45034,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668592550310,
      course: 257,
    },
  },
  {
    id: 45035,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668592573877,
      course: 257,
    },
  },
  {
    id: 45036,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668592691541,
      course: 257,
    },
  },
  {
    id: 45037,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668592751366,
      course: 257,
    },
  },
  {
    id: 45038,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668592788307,
      course: 257,
    },
  },
  {
    id: 45039,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668592847429,
      course: 257,
    },
  },
  {
    id: 45040,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668592847480,
      course: 257,
    },
  },
  {
    id: 45041,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668592851891,
      course: 257,
    },
  },
  {
    id: 45042,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668592872775,
      course: 257,
    },
  },
  {
    id: 45043,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668592872832,
      course: 257,
    },
  },
  {
    id: 45044,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668592885146,
      course: 257,
    },
  },
  {
    id: 45045,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668592975924,
      course: 257,
    },
  },
  {
    id: 45046,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668592976007,
      course: 257,
    },
  },
  {
    id: 45047,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668592977372,
      course: 257,
    },
  },
  {
    id: 45048,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668592977763,
      course: 257,
    },
  },
  {
    id: 45049,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668593006390,
      course: 257,
    },
  },
  {
    id: 45050,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668593079701,
      course: 257,
    },
  },
  {
    id: 45051,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668594735392,
      course: 257,
    },
  },
  {
    id: 45052,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668594735443,
      course: 257,
    },
  },
  {
    id: 45053,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668595198971,
      course: 257,
    },
  },
  {
    id: 45054,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668598046468,
      course: 257,
    },
  },
  {
    id: 45055,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668598071021,
      course: 257,
    },
  },
  {
    id: 45056,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668598086241,
      course: 257,
    },
  },
  {
    id: 45057,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668598089122,
      course: 257,
    },
  },
  {
    id: 45058,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668598096394,
      course: 257,
    },
  },
  {
    id: 45059,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668598107077,
      course: 257,
    },
  },
  {
    id: 45060,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668598117133,
      course: 257,
    },
  },
  {
    id: 45061,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668598119402,
      course: 257,
    },
  },
  {
    id: 45062,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668598225867,
      course: 257,
    },
  },
  {
    id: 45063,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668598338216,
      course: 257,
    },
  },
  {
    id: 45064,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668598349337,
      course: 257,
    },
  },
  {
    id: 45065,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668598415046,
      course: 257,
    },
  },
  {
    id: 45066,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668598431107,
      course: 257,
    },
  },
  {
    id: 45067,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668598448116,
      course: 257,
    },
  },
  {
    id: 45068,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668598505917,
      course: 257,
    },
  },
  {
    id: 45069,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668598587312,
      course: 257,
    },
  },
  {
    id: 45070,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668599299624,
      course: 257,
    },
  },
  {
    id: 45071,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668599299686,
      course: 257,
    },
  },
  {
    id: 45072,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668599406845,
      course: 257,
    },
  },
  {
    id: 45073,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668599428008,
      course: 257,
    },
  },
  {
    id: 45074,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668599853467,
      course: 257,
    },
  },
  {
    id: 45075,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668600057916,
      course: 257,
    },
  },
  {
    id: 45076,
    user: 4783,
    course_id: 257,
    payload: {
      user: 4783,
      os: { name: 'Mac OS', version: '10.15.7' },
      browser: { name: 'Chrome', version: '107.0.0.0', major: '107' },
      time: 1668600059247,
      course: 257,
    },
  },
];
